<template>
<nav class="navbar navbar-expand-md navbar-dark fixed-navbar" id="maintopbar">
	<Pais />
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
    <ul class="navbar-nav ml-auto">
      <li class="nav-link moneda" v-if="indicadores.uf">UF: {{indicadores.uf}}</li>
      <li class="nav-link moneda" v-if="indicadores.dolar">DÓLAR: {{indicadores.dolar}}</li>
			<li class="nav-item align-self-center">
				<router-link class="nav-link" :to="{ name: 'Perfil' }" >
					<img :src="require('@/assets/images/ico-svg/Perfil.svg')" class="navbar-icon" alt="Perfil"> {{useraccess}}
				</router-link>
			</li>
			<li class="nav-item">
        <a class="nav-link" href="#" @click.prevent="CerrarSesion()">
					<img :src="require('@/assets/images/ico-svg/Candado.svg')" class="navbar-icon" alt="Cerrar sesión"> Cerrar sesión
				</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" @click.prevent="showObs">
				  <span class="navbar-icon-wrapper">
						<img :src="require('@/assets/images/ico-svg/Notificacion.svg')" class="navbar-icon" alt="Notificaciones">
						<span v-if="this.testimonios.length>0" :class="{'badge':this.testimonios.length>0 , 'badge2':this.testimonios.length===0}">{{this.testimonios.length}}</span>
				  </span>
				</a>
      </li>
    </ul>
  </div>
	<!--Notificacion-->
	<div class="container-observacion" id="myForm" v-if="observaciones">
		<span  v-if="testimonios.length>0"></span>
		<span class="notification-vacia" v-else>
      <p class="m-0">
        <i class="material-icons">notifications</i>
      </p>
      <p class="m-0">Sin Notificaciones</p>
    </span>
    <div class="container-noti">
      <div class="box-notification" v-for="(t, index) in testimonios" v-bind:key="index">
        <p><span>{{t.nombre}} {{t.hora_recepcion}} <br> {{t.estado_resumen}}:{{t.tipo_movimiento}}</span>
        <router-link :to="{ name : 'LinkNegocio', params: { credito: t.idLeasing_credito, empresa: t.rut }  }"><br>IDº {{t.idLeasing_credito}}</router-link>
        </p>
      </div>
    </div>
	</div>
	<div class="barrita"></div>
		<!--End Notificacion-->
</nav>
</template>

<script>
import Pais from '@/components/ui/Pais'
import { mapState, mapActions } from 'vuex'
export default {
	name: 'Navbar',
	components: {
		Pais
	},
	methods: {
		...mapActions([
			'logout', 'setIndicadores', 'setTiposMonedas'
		]),
		CerrarSesion () {
			this.logout()
		},
		showObs () {
			if (this.observaciones) {
				this.observaciones = false
			} else {
				this.observaciones = true
			}
		},
		apiIndicadoresDiarios () {
			var currentDateWithFormat = new Date().toJSON().slice(0, 10)
			var res = currentDateWithFormat.split('-')
			this.axios.get('https://mindicador.cl/api/uf/' + res[2] + '-' + res[1] + '-' + res[0], {}).then(response => {
				this.valor_uf = response.data.serie[0].valor
			}).catch(error => {
				console.log(error.response.data)
			})
			this.axios.get('https://mindicador.cl/api/dolar/' + res[2] + '-' + res[1] + '-' + res[0], {}).then(response => {
				this.valor_dolar = response.data.serie[0].valor
			}).catch(error => {
				console.log(error.response.data)
			})
		},
		getIndicadores () {
			const auth = {
				headers: { 'Authorization': this.accessToken }
			}
			this.axios.post(this.apiurl + 'IngresoNegocio/getindicadores2', {
				idPais: this.pais.code
			}, auth).then(response => {
				this.setIndicadores(response.data.result)
			}).catch(error => {
				console.log(error)
			})
		},
		getTiposMonedas () {
			const auth = {
				headers: { 'Authorization': this.accessToken }
			}
			this.axios.post(this.apiurl + 'Facturacion/getTiposMonedas', { idPais: this.pais.code }, auth).then(response => {
				this.setTiposMonedas(response.data.result)
			}).catch(error => {
				console.log(error.response.data.mensaje)
			})
		}
	},
	mounted () {
		if (!this.accessToken) this.$router.push('Login')
		const auth = {
			headers: { 'Authorization': this.accessToken }
		}
		this.axios.post(this.apiurl + 'Testimonios/getTestimoniosRelevo', {}, auth).then(response => {
			if (response.data.token !== this.accessToken) {
				this.logout()
			}
			this.testimonios = response.data.testimonios
		}).catch(error => {
			if (error.response.data.token !== this.accessToken) { this.logout() }
			// alert(error.response.data.mensaje)
			this.isLoading = false
		})
		this.apiIndicadoresDiarios()
		this.getIndicadores()
		this.getTiposMonedas()
	},
	watch: {
		pais: function (val) {
			if (val) {
				this.getIndicadores()
				this.getTiposMonedas()
			}
		}
	},
	data () {
		return {
			testimonios: [],
			observaciones: '',
			uf: 0,
			dolar: 0
		}
	},
	computed: {
		...mapState([
			'accessToken',
			'logginIn',
			'loginError', 'apiurl', 'useraccess', 'pais', 'indicadores'])
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue